/* eslint-disable import/no-anonymous-default-export */
import ProductLoanActionTypes from './product-loan-proposal.types';

const INITIAL_STATE = {
	addProductLoanPropsalResponse: null,
	updateProductLoanProposalResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START ADD PRODUCT LOAN PROPOSAL  ******************** */

		case ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addProductLoanPropsalResponse: action.payload };

		case ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_FAILURE:
			return { ...state, addProductLoanPropsalResponse: action.payload };

		case ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addProductLoanPropsalResponse: null };
		/** *********************  END ADD PRODUCT LOAN PROPOSAL  ******************** */

		/** *********************  START UPDATE PRODUCT LOAN PROPOSAL  ******************** */

		case ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateProductLoanProposalResponse: action.payload };

		case ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateProductLoanProposalResponse: action.payload };

		case ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateProductLoanProposalResponse: null };
		/** *********************  END UPDATE PRODUCT LOAN PROPOSAL  ******************** */

		default:
			return state;
	}
};
